import { Component } from '@angular/core';
import { IonicPage, NavController, ToastController } from 'ionic-angular';

import { Address } from '../../models/address';

import { AddressPage } from '../address/address';
import { BasketProvider } from '../../providers/basket/basket';
import { PageBase } from '../page-base';
import { AddressProvider } from '../../providers/address/address';
import { OrderProvider } from '../../providers/order/order';
import { Order } from '../../models/order';
import { CompanyConfigProvider } from '../../providers/company-config/company-config';
import { Method } from '../../models/company-config';
import { AccountProvider } from '../../providers/account/account';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { HomePage } from '../home/home';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RegisterModel, LoginProvider } from '../../providers/login/login';
import { Product } from '../../models/product';
import { ProductProvider } from '../../providers/product/product';

@IonicPage()
@Component({
  selector: 'page-order',
  templateUrl: 'order.html'
})
export class OrderPage extends PageBase {

  products: Array<Product> = new Array<Product>();

  paymentMethods: Array<Method>;
  deliveryMethods: Array<Method>;
  TermsAndConditionsUrl: string;

  step: string = 'delivery';

  liveryAddress: string;
  invoiceAddress: string;

  deliveryMethod: string;
  paymentMethod: string;

  isTermsAccepted = false;

  addresses: Array<Address>;

  isAnonymousUser: boolean;

  customer = new RegisterModel();

  submitAttempt: boolean;
  registerForm: FormGroup;

  // Tax Calculation
  incVatCalc: boolean;
  excVatCalc: boolean = true;
  noVatCalc: boolean;

  totalIncVat: number;
  totalExcVat: number;
  totalVat: number;
  vats: { name: string, value: number }[] = [];

  arePricesAvailable = true;

  remarks: string;

  isConfirmButtonEnabled = true;

  showPrice: boolean;

  constructor(private basketProvider: BasketProvider,
    private addressProvider: AddressProvider,
    private navCtrl: NavController,
    private orderProvider: OrderProvider,
    private companyConfigProvider: CompanyConfigProvider,
    private accountProvider: AccountProvider,
    private iab: InAppBrowser,
    private formBuilder: FormBuilder,
    private loginProvider: LoginProvider,
    private productProvider: ProductProvider,
    private toastCtrl: ToastController) {
    super();

    if (this.loginProvider.isAnonymousSession) {
      this.initForm();
      this.isAnonymousUser = true;
    }

    this.loadAddresses();

    companyConfigProvider.getPaymentMethods().then(x => {
      this.paymentMethods = x;
      this.paymentMethod = this.paymentMethods[0].uuid;
    });

    companyConfigProvider.getDeliveryMethods().then(x => {
      this.deliveryMethods = x;
      this.deliveryMethod = this.deliveryMethods[0].uuid;
    });

    companyConfigProvider.getTermsAndConditionsUrl().then(x => {
      this.TermsAndConditionsUrl = x;
    });

    companyConfigProvider.canSeePrice().then(x => {
      this.showPrice = x;
    });
  }

  calculateVats() {
    this.totalIncVat = this.products.map(x => x.price_including_vat * x.quantity).reduce((x, y) => x + y);
    this.totalExcVat = this.products.map(x => x.price_excluding_vat * x.quantity).reduce((x, y) => x + y);
    this.totalVat = this.totalIncVat - this.totalExcVat;

    if (!this.noVatCalc && this.products.map(x => x.vat != null).reduce((x, y) => x && y)) {
      var c = this.products.map(x => x.vat.name);
      c = c.filter((elem, index, self) => index == self.indexOf(elem));
      this.vats = c.map(x => {
        var total = this.products
          .filter(p => p.vat.name == x)
          .map(p => (p.price_including_vat - p.price_excluding_vat) * p.quantity)
          .reduce((a, b) => a + b);
        return { name: x, value: total };
      });
    }

  }

  /**
  * Adds the product with the specified id to the basket.
  */
  async addItem(id: string) {
    // Get product for id
    var p = await this.productProvider.getProduct(id);
    // Get quantity for product
    p.quantity = this.basketProvider.getProductQuantity(p.uuid);
    // Add product to list if quantity larger than 0
    if (p.quantity > 0) {
      this.products.push(p);
      // Determine if price is available
      if (!p.price_excluding_vat || p.price_excluding_vat == 0) this.arePricesAvailable = false;
    }
  }

  private loadAddresses() {
    if (this.isAnonymousUser) {
      var n = new Array<Address>();
      this.addressProvider.getAddresses().forEach(x => n.push(x));
      this.addresses = n;
      var l = this.addresses.find(x => x.type.name == "DELIVERY");
      var i = this.addresses.find(x => x.type.name == "INVOICE");
      if (l) this.liveryAddress = l.uuid;
      if (i) this.invoiceAddress = i.uuid;
    } else {
      this.accountProvider.getAccount().then(a => {
        this.addresses = a.contact_details.addresses;
        var addr = this.addresses.find(x => x.type.name == "DELIVERY");
        if (addr) this.liveryAddress = addr.uuid;
        addr = this.addresses.find(x => x.type.name == "INVOICE");
        if (addr) this.invoiceAddress = addr.uuid;
      });
    }
  }

  private initForm() {
    this.registerForm = this.formBuilder.group({
      firstname: ['', Validators.compose([Validators.required])],
      lastname: ['', Validators.compose([Validators.required])],
      mail: ['', Validators.compose([Validators.email, Validators.required])],
	  phone: ['', Validators.compose([Validators.pattern(/^\+(?:[0-9] ?){6,14}[0-9]$/), null])]

    });
  }

  async ionViewDidLoad() {
    var basket = this.basketProvider.basket;
    for (let i = 0; i < basket.length; i++) {
      // Add product for each basket item
      await this.addItem(basket[i].productId);
    }
    this.calculateVats();
  }

  /**
  * Returns true if the user really intended to leave the order page.
  */
  canLeave = false;
  ionViewCanLeave() {
    if (this.addingAddress) {
      return true;
    }
    if (!this.canLeave) {
      this.alertProvider.cancelOrderPageAlert(() => {
        this.canLeave = true;
        this.navCtrl.pop();
      });
    }
    return this.canLeave;
  }

  addingAddress = false;
  ionViewWillEnter() {
    if (this.addingAddress) {
      this.loadAddresses();
      this.addingAddress = false;
    }
  }

  /**
  * Pushes address page.
  */
  addAddress() {
    var x = new Address();
    this.addingAddress = true;
    this.navCtrl.push(AddressPage, { 'address': x });
  }

  /**
  * Switches to payment segment.
  */
  continueToPayment() {
    if (!this.invoiceAddress) {
      this.alertProvider.simple('ORDER.NO_ADDRESS_SELECTED_TITLE', 'ORDER.NO_INVOICE_ADDRESS_SELECTED_MESSAGE');
    } else if (!this.liveryAddress || this.liveryAddress.length < 2) {
      this.alertProvider.simple('ORDER.NO_ADDRESS_SELECTED_TITLE', 'ORDER.NO_DELIVERY_ADDRESS_SELECTED_MESSAGE');
      return;
    } else {
      if (this.isAnonymousUser && this.step == 'delivery') {
        this.step = 'userDetails';
      } else if (this.step == 'userDetails') {
        if (this.registerForm.valid) {
          this.step = 'payment';
        } else {
          this.submitAttempt = true;
        }
      } else {
        this.step = 'payment';
      }
    }
  }

  /**
  * Switches to confirmation segment.
  */
  continueToConfirmation() {
    this.step = 'confirmation';
  }

  /**
  * Confirms the order if requirements are met.
  */
  async confirmOrder() {
    this.isConfirmButtonEnabled = false;
    if (this.addresses.length == 0) {
      this.alertProvider.simple('ORDER.NO_ADDRESS_DIALOG_TITLE', 'ORDER.NO_ADDRESS_DIALOG_MESSAGE');
      this.isConfirmButtonEnabled = true;
      return;
    }
    if (this.isTermsAccepted) {
      if (await this.submitOrder()) {
        this.basketProvider.clearBasket();
        this.canLeave = true;
        this.navCtrl.setRoot(HomePage);
        this.alertProvider.customButton('ORDER.ORDER_PLACED_DIALOG_TITLE', 'ORDER.ORDER_PLACED_DIALOG_MESSAGE', 'GENERIC.OK');
      } else {
        this.isConfirmButtonEnabled = true;
      }
    } else {
      this.alertProvider.simple('ORDER.LICENSE_DIALOG_TITLE', 'ORDER.LICENSE_DIALOG_MESSAGE');
      this.isConfirmButtonEnabled = true;
    }
  }

  async submitOrder(): Promise<boolean> {
    var order = new Order();
    order.store_uuid = this.appConfig.companyId;
    if (this.isAnonymousUser) {
      order.firstname = this.customer.firstname;
      order.lastname = this.customer.lastname;
      order.phonenumber = this.customer.phone;
      order.emailaddress = this.customer.email;
    } else {
      order.customer_uuid = await this.accountProvider.getAccount().then(x => x.uuid);
    }
    order.invoiceAddress = this.getAddress(this.invoiceAddress);
    order.deliveryAddress = this.getAddress(this.liveryAddress);
    order.delivery_method_uuid = this.deliveryMethod;
    order.payment_method_uuid = this.paymentMethod;
    order.orderLines = this.basketProvider.getOrderLines();
    order.remarks = this.remarks;
    return this.orderProvider.submitOrder(order);
  }

  /**
   * Returns the address that belongs to the id
   * @param uuid Id of address
   */
  getAddress(uuid: string): Address {
    return this.addresses.find(x => x.uuid == uuid);
  }

  /**
   * Returns a string of the specified address.
   * @param uuid Id of address
   */
  getAddressString(uuid: string): String {
    return this.getAddress(uuid).toString();
  }

  /**
   * Shows terms of agreement in InAppBrowser
   */
  private termsOfAgreement() {
	  if(this.TermsAndConditionsUrl && this.TermsAndConditionsUrl != null){
		  this.iab.create(this.TermsAndConditionsUrl);
	  }else{
		   let toast = this.toastCtrl.create({
		    message: this.translate.instant('GENERIC.LICENSE_NONE'),
		    duration: 3000,
		    position: 'bottom'
		  });
	  
		  toast.present();
	  }
  }
}


// WEBPACK FOOTER //
// ./src/pages/order/order.ts